<!--
* UIID: 
* UI Name: File Detail
* Modify Date: 2020/10/07
-->
<template>
  <div>
    <v-card class="p-2 card-folder" :class="viewMode">
      <v-row dense>
        <v-col cols="9"></v-col>
        <v-col cols="3" class="text-right">
          <dropdownMenu
            :dataValue="item"
            @click-event="onClickMenu($event)"
            @edit-event="onClickMenu($event)"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" class="pt-2 text-sm text-center">
          <!-- <v-icon v-if="item.type=='D'" x-large>fa fa-folder</v-icon>
          <v-icon v-if="item.type=='F'" x-large>fa fa-file{{getIconTxt(item.USR_FILE_TYPE)}}</v-icon> -->
          <v-icon x-large>fa fa-file{{getIconTxt(item.USR_FILE_TYPE)}}</v-icon>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" class="text-xs text-center folder-file-name">{{ item.USR_FILE_NAME }}</v-col>
      </v-row>

      <v-row dense>
        <v-col cols="7" class="text-xs text-left uppercase">
          <v-chip x-small label :color="getChipColor(item.USR_FILE_TYPE)">{{ item.USR_FILE_TYPE }}</v-chip>
        </v-col>
        <v-col cols="5" class="text-xs text-right">{{ item.USR_FILE_SIZE }}</v-col>
      </v-row>
    </v-card>
     <dialogWindow
        size="max"
        title="View Data"
        scrollable
        :detail="inputFileContent"
        :isCode="true"
        color="information"
        ref="viewFile"
    ></dialogWindow>
  </div>
</template>


<script>
import dropdownMenu from "@/vue-caas/views/folder/FileDropdownMenu.vue";
import { mapState } from "vuex";
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'


export default {
  components: {
    dropdownMenu,
    dialogWindow
  },

  props: {
    detail: {
      default: Object
    }
  },
  data: () => ({
    item: {
      default: Object
    },
    view: true,
    edit: false,
    inputFileContent:''
  }),

  created() {
    this.initialize();
  },

  computed: {
    viewMode() {
      return this.view ? "" : "d-none";
    },
    editMode() {
      return this.edit ? "" : "d-none";
    },
    ...mapState("common", {
      fileContent: "fileContent",      
    }),
  },

  methods: {
    initialize() {
      this.item = JSON.parse(JSON.stringify(this.detail));
    },

    getColorFromText(text) {
      let colorCode = text.charCodeAt(0);
      let colorNum = colorCode % 18;
      let colorStr = "success";

      if (colorNum == 0) {
        colorStr = "red";
      } else if (colorNum == 1) {
        colorStr = "pink";
      } else if (colorNum == 2) {
        colorStr = "purple";
      } else if (colorNum == 3) {
        colorStr = "deep-purple";
      } else if (colorNum == 4) {
        colorStr = "indigo";
      } else if (colorNum == 5) {
        colorStr = "blue";
      } else if (colorNum == 6) {
        colorStr = "light-blue";
      } else if (colorNum == 7) {
        colorStr = "cyan";
      } else if (colorNum == 8) {
        colorStr = "teal";
      } else if (colorNum == 9) {
        colorStr = "green";
      } else if (colorNum == 10) {
        colorStr = "light-green";
      } else if (colorNum == 11) {
        colorStr = "lime";
      } else if (colorNum == 12) {
        colorStr = "yellow";
      } else if (colorNum == 13) {
        colorStr = "amber";
      } else if (colorNum == 14) {
        colorStr = "orange";
      } else if (colorNum == 15) {
        colorStr = "deep-orange";
      } else if (colorNum == 16) {
        colorStr = "brown";
      } else if (colorNum == 17) {
        colorStr = "blue-grey";
      }

      return colorStr + " accent-3";
    },

    getStatusColor(status) {
      let color = "";

      if (status == "Confirmed") {
        color = "success darken-4";
      } else if (status == "Waiting Confirmation") {
        color = "warning darken-4";
      }

      return color;
    },

    onClickMenu(item) {
      let value = item.value;
      //Event when click menu open
      if (item.code == "O") {
        Store.dispatch("common/viewFileData", this.item.FILE_ID).then(() => {
          if(typeof this.fileContent === 'object'){
            this.inputFileContent = JSON.stringify(this.fileContent, null, '\t');
          }else{
            this.inputFileContent = this.fileContent.toString();
          }
          this.$refs.viewFile.dialog=true;
          }
        );
      } else if (item.code == "D") {
        alert("delete:::::\n" + JSON.stringify(value));
      }
    },

    cancelEdit() {
      this.initialize();

      this.view = true;
      this.edit = false;
    },

    okEdit() {
      this.view = true;
      this.edit = false;
    },

    getIconTxt(str) {
      let txt = "-alt";

      if (str == "csv" || str == "pdf") {
        txt = "-" + str;
      } else if (str == "xml") {
        txt = "-" + "code";
      }
      else if (str == "txt" || str == "biz" || str == "edi" || str == "json") {
        txt = "-" + "alt";
      }else{
        txt = "-" + "code";
      }
      return txt;
    },

    getChipColor(str) {
      let txt = "";

      if (str == "csv") {
        txt = "success";
      } else if (str == "pdf") {
        txt = "error";
      } else if (str == "xml") {
        txt = "primary";
      } else if (str == "folder") {
        txt = "warning lighten-2";
      }

      return txt;
    }
  }
};
</script>

<style>
.theme--light .card-folder.v-sheet{
  border: 1px solid #E6EBF3;
  border-radius: 4px;
}
.theme--dark .card-folder.v-sheet{
  border: none;
}
.folder-file-name{
  white-space: nowrap; 
  width: 100%; 
  overflow: hidden;
  text-overflow: ellipsis; 
}
</style>